import React, { useState, useEffect } from 'react';
import { sanitizeInput } from '../sanitize.js';
import { useLoading } from '../LoadingContext';  // ★ 追加
import '../../styles/OrganizationSection.css';

const API_BASE = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/companies';

const OrganizationSection = () => {
  const { startLoading, finishLoading } = useLoading();  // ★ 追加
  const [companies, setCompanies] = useState([]);
  const [newCompanyName, setNewCompanyName] = useState('');
  const [newCompanyPeriod, setNewCompanyPeriod] = useState(30);

  const [modalCompany, setModalCompany] = useState(null);
  const [dailyReportUrl, setDailyReportUrl] = useState('');

  // --- 初回ロード ---
  useEffect(() => {
    const init = async () => {
      startLoading();
      try {
        await loadCompanies();
      } finally {
        finishLoading();
      }
    };
    init();
  }, []);

  const loadCompanies = async () => {
    try {
      const res = await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'list' }),
      });
      const data = await res.json();
      setCompanies(data.companies || []);
    } catch (err) {
      console.error('❌ loadCompanies error', err);
      alert('組織一覧の取得に失敗しました');
    }
  };

  const handleRegisterCompany = async () => {
    const name = sanitizeInput(newCompanyName);
    if (!name) {
      alert('企業名を入力してください');
      return;
    }
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          action: 'register',
          name,
          days: Number(newCompanyPeriod),
        }),
      });
      setNewCompanyName('');
      setNewCompanyPeriod(30);
      await loadCompanies();
    } catch (err) {
      console.error('❌ registerCompany error', err);
      alert('登録中にエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  const handleExtendToken = async (companyId, days) => {
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'extend', companyId, days }),
      });
      await loadCompanies();
    } catch (err) {
      console.error('❌ extendToken error', err);
      alert('延長処理でエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  const handleReissueToken = async (companyId) => {
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'reissue', companyId }),
      });
      await loadCompanies();
    } catch (err) {
      console.error('❌ reissueToken error', err);
      alert('再発行でエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  const handleUpdateMaxUsers = async (companyId, maxUsers) => {
    if (!Number.isInteger(maxUsers) || maxUsers < 1) {
      alert('1以上の整数を入力してください');
      return;
    }
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          action: 'update-max-users',
          companyId,
          maxUsers,
        }),
      });
      await loadCompanies();
    } catch (err) {
      console.error('❌ updateMaxUsers error', err);
      alert('上限変更中にエラーが発生しました');
    } finally {
      finishLoading();
    }
  };  

  const handleToggleStatus = async (companyId, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    const confirmMessage = newStatus === 1
      ? 'このトークンを稼働状態にしますか？'
      : 'このトークンを停止状態にしますか？';
    if (!window.confirm(confirmMessage)) return;

    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'status', companyId, status: newStatus }),
      });
      await loadCompanies();
    } catch (err) {
      console.error('❌ toggleStatus error', err);
      alert('ステータス切替でエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  const handleDeleteCompany = async (companyId) => {
    if (!window.confirm('この組織を削除します。よろしいですか？')) return;

    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'delete', companyId }),
      });
      await loadCompanies();
    } catch (err) {
      console.error('❌ deleteCompany error', err);
      alert('削除中にエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  const formatDate = (isoString) => isoString.slice(0, 10);

    const openEditModal = (company) => {
    setModalCompany(company);
    setDailyReportUrl(company.daily_report_url || '');
  };

  const handleSaveDailyReportUrl = async () => {
    const url = sanitizeInput(dailyReportUrl);
    if (!url || !modalCompany) return;

    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          action: 'update-daily-report-url',
          companyId: modalCompany.id,
          url
        }),
      });
      setModalCompany(null);
      await loadCompanies();
    } catch (err) {
      console.error('❌ updateDailyReportUrl error', err);
      alert('日報URLの更新に失敗しました');
    } finally {
      finishLoading();
    }
  };

  return (
    <div className="organization-section">
      <h3>新規事業所登録</h3>
      <input
        placeholder="事業所名"
        value={newCompanyName}
        onChange={(e) => setNewCompanyName(e.target.value)}
        disabled={false}
      />
      <select
        value={newCompanyPeriod}
        onChange={(e) => setNewCompanyPeriod(Number(e.target.value))}
      >
        <option value={30}>30日</option>
        <option value={90}>90日</option>
        <option value={365}>1年</option>
      </select>
      <button onClick={handleRegisterCompany}>登録</button>

      <h3>事業所一覧</h3>
      <table>
        <thead>
          <tr>
            <th>事業所名</th>
            <th>稼働ステータス</th>
            <th>トークン</th>
            <th>期限</th>
            <th>期間延長</th>
            <th>利用者登録上限</th>
            <th>日報システム</th>
            <th>再発行</th>
            <th>一時停止 / 稼働</th>
            <th>削除</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((company) => (
            <tr key={company.id}>
              <td>{company.name}</td>
              <td>{company.status === 1 ? '稼働中' : '停止中'}</td>
              <td>
                {company.manager_token}
                <button
                  className="copy-button"
                  onClick={() => {
                    navigator.clipboard.writeText(company.manager_token);
                    alert('コピーしました');
                  }}
                >
                  コピー
                </button>
              </td>
              <td>{formatDate(company.token_expiry_at)}</td>
              <td>
                <button
                  className="secondary-button"
                  onClick={() => handleExtendToken(company.id, 30)}
                >
                  30日延長
                </button>
                <button
                  className="secondary-button"
                  onClick={() => handleExtendToken(company.id, 90)}
                >
                  90日延長
                </button>
                <button
                  className="secondary-button"
                  onClick={() => handleExtendToken(company.id, 365)}
                >
                  1年延長
                </button>
              </td>
              <td>
                <input
                  type="number"
                  min={1}
                  value={company.max_users}
                  onChange={(e) => {
                    const updated = [...companies];
                    const index = updated.findIndex((c) => c.id === company.id);
                    updated[index] = {
                      ...updated[index],
                      max_users: parseInt(e.target.value, 10)
                    };
                    setCompanies(updated);
                  }}
                  style={{ width: '60px', marginRight: '8px' }}
                />
                <button
                  className="secondary-button"
                  onClick={() => handleUpdateMaxUsers(company.id, company.max_users)}
                >
                  変更
                </button>
              </td>
              <td>
                {company.daily_report_url ? '登録済' : '未登録'}
                <button onClick={() => openEditModal(company)}>編集</button>
              </td>
              <td>
                <button onClick={() => handleReissueToken(company.id)}>
                  再発行
                </button>
              </td>
              <td>
                <button
                  className={company.status === 1 ? 'danger-button' : 'secondary-button'}
                  onClick={() => handleToggleStatus(company.id, company.status)}
                >
                  {company.status === 1 ? '停止' : '稼働'}
                </button>
              </td>
              <td>
                <button
                  className="danger-button"
                  onClick={() => handleDeleteCompany(company.id)}
                >
                  削除
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalCompany && (
        <div className="daily-url-modal-overlay">
          <div className="daily-url-modal">
            <h4>日報システムURLの編集</h4>
            <p>{modalCompany.name}</p>
            <input
              type="text"
              placeholder="https://..."
              value={dailyReportUrl}
              onChange={(e) => setDailyReportUrl(e.target.value)}
            />
            <div className="daily-url-modal-actions">
              <button onClick={handleSaveDailyReportUrl}>保存</button>
              <button onClick={() => setModalCompany(null)}>キャンセル</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationSection;
